import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { PropType, ref, watch } from "vue";
import { useAsyncSpinner } from "@/services/Spinner";
import { useCart } from "@/store/useCart";
import { IPagination } from "@/models/IPagination";
import { DataLayerApi, SearchApi } from "@/services/Api";
import { Sorting } from "@/models/Search";
import { getSearchProducts } from "@/code/GoogleEventTracking";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSearchPageWrapper',
  props: {
  pagination: {
    type: Object as PropType<IPagination>,
    required: true,
  },
  term: {
    type: String,
    required: true,
  },
  showOnlyAgreementProducts: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const cartStore = useCart();



const pagination = ref<IPagination>(props.pagination);
const hideInitialProducts = ref<boolean>(false);
const products = ref<any>([]);
const favorited = ref<Array<string>>([]);
const isSortOpen = ref<boolean>(false);
const url = new URL(window.location.href);
const sorting = ref<Sorting>((url.searchParams.get("sorting") as Sorting) || Sorting.RelevanceDesc);
const showOnlyAgreementProducts = ref<boolean>(props.showOnlyAgreementProducts);

const toggleDisplayMode = () => {
  showOnlyAgreementProducts.value = !showOnlyAgreementProducts.value;
  reloadProducts();
};

const _setUrlParamAndPushState = (key: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState(null, "", url);
};

const onSortChange = (ev) => {
  sorting.value = ev.target.value;
  _setUrlParamAndPushState("sorting", sorting.value.toString());
  reloadProducts();
};

const isFavorited = (id: string) => {
  return favorited.value.find((x) => x == id);
};

const onFavoriteClick = (id: string) => {
  const val = favorited.value.find((x) => x == id);
  if (val) {
    favorited.value = favorited.value.filter((x) => x != id);
  } else {
    favorited.value.push(id);
  }
};

const onCartClick = async (partNo: string, quantity: number): Promise<void> => {
  await useAsyncSpinner(async () => {
    await cartStore.addToCart(partNo, quantity, true);
     if (typeof window !== "undefined" && window.BiTracking) {
      const row = cartStore.rows.find((r) => r.item.partNo === partNo);
      window.BiTracking.addToBasket(partNo, row?.quantity, "", cartStore.id, "");
    }
  });
};

const onMoveToTopClick = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const openSort = () => {
  isSortOpen.value = true;
};

const closeSort = () => {
  isSortOpen.value = false;
};

const onToggleSortClick = () => {
  if (isSortOpen.value) {
    closeSort();
  } else {
    openSort();
  }
};

const nextPage = async () => {
  pagination.value.currentPage++;
  _setUrlParamAndPushState("pageNo", pagination.value.currentPage.toString());
  const res = await SearchApi.products(
    props.term,
    pagination.value.currentPage,
    sorting.value,
    false,
    showOnlyAgreementProducts.value
  );
  pagination.value = res.pagination;
  products.value = [...products.value, ...res.products];
};

const reloadProducts = async () => {
  _setUrlParamAndPushState("pageNo", pagination.value.currentPage.toString());
  const res = await SearchApi.products(
    props.term,
    pagination.value.currentPage,
    sorting.value,
    true,
    showOnlyAgreementProducts.value
  );
  hideInitialProducts.value = true;
  pagination.value = res.pagination;
  products.value = res.products;
};

const initialProducts = getSearchProducts();

watch(products, (currVal) => {
  const currValSkus = currVal.map((x) => x.sku);
  const combinedProducts = initialProducts.concat(currValSkus);
  DataLayerApi.createViewItemListEvent("search-page", combinedProducts);
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    hideInitialProducts: hideInitialProducts.value,
    onCartClick: onCartClick,
    isFavorited: isFavorited,
    onFavoriteClick: onFavoriteClick,
    onMoveToTopClick: onMoveToTopClick,
    pagination: pagination.value,
    nextPage: nextPage,
    products: products.value,
    isSortOpen: isSortOpen.value,
    onToggleSortClick: onToggleSortClick,
    sorting: sorting.value,
    onSortChange: onSortChange,
    totalHits: pagination.value.totalHits,
    showOnlyAgreementProducts: showOnlyAgreementProducts.value,
    onToggleDisplayMode: toggleDisplayMode
  })
}
}

})